import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../components/Common/calender-icon.css";
import { dateFormat } from "../../Helper/common";
import { formInputErrorMsg } from "./empConstants";

function EMPDate(props) {
  const {
    name,
    id,
    fieldId,
    paramStartDate,
    intialStatus,
    placeholder,
    errId,
    isRequired,
    isDisabled = false,
    hasError = null,
    saveDate,
    checkDetailsIndex,
    fieldName,
    fieldValue,
    checkID,
    minDateDOL = null,
    maxDOJDate = null,
    placeholderStyle,
    divClass,
    nomineeIndex,
    nomineeFieldIdx,
    fieldType,
    EpfData,
    inputVal,
    JLLdoj,
    dob
  } = props;
  const [selectedDate, setSelectedDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [minDate, setMinDate] = useState(null);

  const maxDateSlugArr = [
    'eps_family_member_dob',
    'pension_nominee_dob',
    'nominee_dob',
    'ML_nominee_dob',
    'ML_GTFI_nominee_dob',
    'Form_11_marriage_date',
    'ML_spouse_dob',
    'ML_cheld_1_dob',
    'ML_child_2_dob'
  ]

  useEffect(() => {
    if (fieldValue && fieldValue !== "") {
      if(fieldName == 'OnboardingFields'){
        // let date = fieldValue.split('-')
        const [dd, mm, yyyy] = fieldValue.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);
        if (newDate !== "Invalid date") {
          setSelectedDate(newDate);
        }
      }else{
        const [dd, mm, yyyy] = fieldValue.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);
        if (newDate !== "Invalid date") {
          setSelectedDate(newDate);
        }
      }
    } else if(fieldName != 'OnboardingFields'){
      setSelectedDate('');
    }
    if (checkID == 261 && fieldName == "company_date_of_leaving") { // EMP VIA UAN
      const pastDate = new Date();
      pastDate.setMonth(pastDate.getMonth() + 3); 
      setMinDate(minDateDOL);
      setMaxDate(pastDate);
    }
    if (checkID == 261 && fieldName == "company_date_joining") { // EMP VIA UAN
      if (maxDOJDate) {
        setMaxDate(maxDOJDate);
      } else {
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - 1);
        setMaxDate(pastDate);
      }
    }
    if (checkID == 58 && fieldName == "company_date_of_leaving") {
      const today = new Date();
      setMinDate(today);
      const futureDate = new Date();
      // futureDate.setDate(futureDate.getDate() + 30);
      futureDate.setDate(futureDate.getDate() + 365);
      setMaxDate(futureDate);
    }
    if (checkID == 58 && fieldName == "company_date_joining") {
      const pastDate = new Date();
      pastDate.setDate(pastDate.getDate() - 1);
      setMaxDate(pastDate);
    }
    if (checkID == 41 && fieldName == "company_date_of_leaving") {
      if(JLLdoj) {
        const [dd, mm, yyyy] = JLLdoj.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);
        if (newDate !== "Invalid date") {
          newDate.setDate(newDate.getDate() - 1)
          setMinDate(minDateDOL);
          setMaxDate(newDate);
        }
      } else {
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - 1);
        setMinDate(minDateDOL);
        setMaxDate(pastDate);
      }
    }
    if (checkID == 41 && fieldName == "company_date_joining") {
      if (maxDOJDate) {
        setMaxDate(maxDOJDate);
      } else if(JLLdoj) {
        const [dd, mm, yyyy] = JLLdoj.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);
        if (newDate !== "Invalid date") {
          newDate.setDate(newDate.getDate() - 1)
          // setMinDate(minDateDOL);
          setMaxDate(newDate);
        }
      } else {
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - 1);
        setMaxDate(pastDate);
      }
    }
    if (fieldName == "reliveing_letter_date") {
      const today = new Date();
      
      if (checkID == 58) {
        setMinDate(today);
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 365);
        setMaxDate(futureDate);
      } else {
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 365); //fix for IB-12546
        setMaxDate(futureDate);
      }

      // if(checkID !== 58) {
      //   setMaxDate(today); //add candidate by HR fix revert ..creating issue for IB-12546
      // }
      // if (checkID == 41) {
      //   setMaxDate(today);
      // }
    }
    if (fieldName == "aadhar_dob") {
      const today = new Date();
      setMaxDate(today);
    }
    if (name == "Form_11_marriage_date" || name == "validity_of_passport_from" || name == 'Form_11_EPF_exempted_trust_doj' || name == 'Form_11_EPF_unexempted_doj') {
      const today = new Date();
      
        // setMinDate(today);
        // const futureDate = new Date();
        // futureDate.setDate(futureDate.getDate() + 365);
        // setMaxDate(today);
      // } else {
      //   const futureDate = new Date();
      //   futureDate.setDate(futureDate.getDate() + 365); //fix for IB-12546
      //   setMaxDate(futureDate);
      }
      // if (name == "eps_family_member_dob" || name == 'pension_nominee_dob' || name == 'nominee_dob' || name == 'ML_nominee_dob' || name == 'ML_GTFI_nominee_dob' || name == 'Form_11_marriage_date' ) {
      if(maxDateSlugArr.includes(name)){
        console.log(name, 'iiiii')
        const today = new Date();
        console.log(today, 'iiiii', minDate, '|||| ',maxDate)
        setMaxDate(today);
      }
      if(name == '221'){
        const today = new Date();
        setMinDate(today);
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 365);
        setMaxDate(futureDate);
      }
      
      if(dob && dob != "null"){
        const [dd, mm, yyyy] = dob.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);
        if (newDate !== "Invalid date") {
          newDate.setDate(newDate.getDate()) //IB-22637
        setMinDate(newDate);
        // setMaxDate(newDate);
        }
      }
  }, [fieldValue, minDateDOL, maxDOJDate]);
  
  useEffect(() => {
    return () => {
      setSelectedDate(null)
  }
  },[])


  const convertToDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
  };
  
  const getMinDate = (name, date) => {
    let newDate;
  
    const getDateFromField = (section, slug) => {
      return EpfData?.[section]?.field_details.find(item => item?.slug === slug)?.value;
    };
  
    switch (name) {
      case 'validity_of_passport_to':
        newDate = inputVal['validity_of_passport_from'] || getDateFromField('Passport Details', 'validity_of_passport_from');
        break;
  
      case 'Form_11_EPF_exempted_trust_dol':
        newDate = inputVal['Form_11_EPF_exempted_trust_doj'] || getDateFromField('Previous Employment Details', 'Form_11_EPF_exempted_trust_doj');
        break;
  
      case 'Form_11_EPF_unexempted_doe':
        newDate = inputVal['Form_11_EPF_unexempted_doj'] || getDateFromField('Previous Employment Details', 'Form_11_EPF_unexempted_doj');
        break;

    }
  
    return newDate;
  };
  

  const getMaxDate = (name, date) => {
    let newDate;
  
    const getDateFromField = (section, slug) => {
      return EpfData?.[section]?.field_details.find(item => item?.slug === slug)?.value;
    };
  
    switch (name) {
      case 'validity_of_passport_from':
        // newDate = inputVal['validity_of_passport_to'] || getDateFromField('Passport Details', 'validity_of_passport_to');
        const tday = new Date();
        let tempDate = inputVal['validity_of_passport_to'] || getDateFromField('Passport Details', 'validity_of_passport_to');
        if(tempDate){

          const [dd,mm,yyyy] = tempDate.split('-');
          let dt = new Date(`${yyyy}-${mm}-${dd}`);
          if(dt !== 'Invalid Date' && yyyy){
            if(dt < tday){
              newDate = tempDate;
            }
          }
          }
            // else{
            // let dd = tday.getDate();
            // dd = dd < 10 == 1 ? `0${dd}` : dd; 
            // let mm = tday.getMonth();
            // mm = mm < 10 == 1 ? `0${mm}` : mm;
            // let year = tday.getFullYear();
            // console.log(`${dd}-${mm}-${year}`, 'tempppxxxx');
            // newDate = `${dd}-${mm}-${year}`;
        //   }
        // }else{
          // let dd = tday.getDate();
          // dd = dd.length == 1 ? `0${dd}` : dd; 
          // let mm = tday.getMonth();
          // mm = mm.length == 1 ? `${mm}` : mm;
          // let year = tday.getFullYear();
          // newDate = `${dd}-${mm}-${year}`;
        // }
        // console.log(tempDate, "tempppp", dt, newDate);
        break;
  
      case 'Form_11_EPF_exempted_trust_doj':
        // newDate = inputVal['Form_11_EPF_exempted_trust_dol'] || getDateFromField('Previous Employment Details', 'Form_11_EPF_exempted_trust_dol');
        // debugger
        const tday1 = new Date();
        let tempDate1 = inputVal['Form_11_EPF_exempted_trust_dol'] || getDateFromField('Passport Details', 'Form_11_EPF_exempted_trust_dol');
        if(tempDate1){
          const [dd1,mm1,yyyy1] = tempDate1.split('-');
          let dt1 = new Date(`${yyyy1}-${mm1}-${dd1}`);
          if(dt1 < tday1){
            newDate = tempDate1;
          }
        }
        // else{
        //   let dd = tday1.getDate();
        //   let mm = tday1.getMonth();
        //   let year = tday1.getYear();
        //   newDate = `${dd}-${mm}-${year}`;
        // }
        break;
  
      case 'Form_11_EPF_unexempted_doj':
        // newDate = inputVal['Form_11_EPF_unexempted_doe'] || getDateFromField('Previous Employment Details', 'Form_11_EPF_unexempted_doe');
        const tday2 = new Date();
        let tempDate2 = inputVal['Form_11_EPF_unexempted_doe'] || getDateFromField('Passport Details', 'Form_11_EPF_unexempted_doe');
        if(tempDate2){
          const [dd2,mm2,yyyy2] = tempDate2?.split('-');
          let dt2 = new Date(`${yyyy2}-${mm2}-${dd2}`);
          if(dt2 < tday2){
            newDate = tempDate2;
          }
        }
        // else{
        //   let dd = tday2.getDate();
        //   let mm = tday2.getMonth();
        //   let year = tday2.getYear();
        //   newDate = `${dd}-${mm}-${year}`;
        // }
        break;

      case 'Form_11_marriage_date':
        const today = new Date();
        newDate = today;
          break;  
  
    }
  
    return newDate;
  };

  useEffect(() => {
    return () => {
      setSelectedDate(null)
  }
  },[])

  const handleThirdPartyFloatingLabel = (e) => {
    let parent = e.target.parentElement;
    while (!parent.classList.contains("floating-label"))
      parent = parent.parentElement;
    if (parent.children[1].classList.contains("focused")) {
      if (selectedDate !== null) {
        return false;
      } else {
        parent.children[1].classList.remove("focused");
      }
    } else {
      parent.children[1].classList.add("focused");
    }
  };

  const dateSelectHandler = (date) => {
    setSelectedDate(date);
    //handleSaveDate("01/12/2021");
    let formatedDate = dateFormat("DD-MM-YYYY", date);

    handleSaveDate(formatedDate);

    //
  };

  const handleSaveDate = (argdate) => {
    // const [day, month, year] = argdate.split("/");
    // const savedDate = day + "-" + month + "-" + year;
    saveDate(checkDetailsIndex, fieldName, argdate, name, errId, nomineeIndex, nomineeFieldIdx);
  };

  let elementClass = 'col-sm-4 col-md-12 col-xl-4';
  if(divClass){
    elementClass = divClass;
  }

  const errorMsg =
    (fieldValue == null || fieldValue == "") && isRequired == 1
      ? formInputErrorMsg.requiredError
      : formInputErrorMsg.InvalidError;

  function getMinDates() {
    if(fieldName == 'OnboardingFields'){
        if ( name == "validity_of_passport_to" || name == 'Form_11_EPF_exempted_trust_dol' || name == 'Form_11_EPF_unexempted_doe') {   
          let dt = getMinDate(name);
          if(dt){
            const newDt = convertToDate(dt);
            return newDt;
          }
        }  
    }        
  } 
  
  function getMaxDates() {
    if(fieldName == 'OnboardingFields'){
      if ( name == "validity_of_passport_from" || name == 'Form_11_EPF_exempted_trust_doj' || name == 'Form_11_EPF_unexempted_doj') {
        let dt = getMaxDate(name);
        if(dt){
          const newDt = convertToDate(dt);
          return newDt;
        }
        else{
          const today = new Date();
          return today;
        }
        }
        if(name == 'Form_11_marriage_date'){
          let dt = getMaxDate(name);
          if(dt){
            return dt;
          }
        }
    }        
  }  

  return (
    <>
      <div className={elementClass}>
        <div className="form-group">
          <div className={`floating-label has-left-icon react-date-picker ${placeholder.length > 25 ? 'small' : ''}`} 
          style={{fontSize: `${placeholder.length > 25 ? 'small' : 'medium'}`}}
          >
            <DatePicker
              key={id}
              className="form-control has-icon calendar-icon text-truncate"
              selected={selectedDate || ''}
              id={props?.id}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => dateSelectHandler(date)}
              onFocus={handleThirdPartyFloatingLabel}
              onBlur={handleThirdPartyFloatingLabel}
              autoComplete="off"
              maxDate={fieldName == 'OnboardingFields'? getMaxDates() : maxDate}
              minDate={fieldName == 'OnboardingFields'? getMinDates() : minDate}
              disabled={isDisabled}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              fixedHeight
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
            <label htmlFor={props?.id || errId} style={placeholderStyle} className={fieldValue && "focused"}>
              {placeholder}
              {isRequired && <sup className="text-danger">*</sup>}
            </label>
          </div>
          {hasError && hasError === true && (
            <p className="err text-danger" id={errId}>
              {errorMsg}
            </p>
          )}
             {fieldType == 'Onboarding' &&
            // props?.customError?<p className="err text-danger">This field is required.</p> : 
            <p className="err text-danger" id={props?.errId}></p> 
          } 
        </div>
      </div>
    </>
  );
}

export default EMPDate;
